import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import { HttpStatusCode } from '@serengeti/serengeti-common';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from '../locale/locale.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { EqualPasswordsValidator } from '../validator/equal-passwords-validator';
import {EmailValidator} from '../validator/email-validator';
import {GuestUserService} from "@serengeti/serengeti-user";


@Component({
  selector: 'app-member-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignUpComponent implements OnInit {

  private toasterService: ToasterService;

  public form: FormGroup;
  public userId: AbstractControl;
  public name: AbstractControl;
  public email:AbstractControl;
  public password:AbstractControl;
  public repeatPassword:AbstractControl;
  public passwords: FormGroup;
  public locale: AbstractControl;

  public loading:boolean = false;
  public submitted = false;

  profile = environment.profile;

  @Input() returnUrl: string;

  constructor(
    fb: FormBuilder,
    private router: Router,
    private guestUserService: GuestUserService,
    private localeService: LocaleService,
    private translateService: TranslateService,
    toasterService: ToasterService
  ) {

    this.form = fb.group({
      'userId': ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(64)])],
      'name': ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(64)])],
      'email': ['', Validators.compose([Validators.required, EmailValidator.validate])],
      'locale': ['ko-kr'],
      'passwords': fb.group({
        'password': ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(64),
          Validators.pattern("^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&\\*\\(\\)])[A-Za-z\\d!@#$%^&\\*\\(\\)]{8,}$")])],
        'repeatPassword': ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(64)])]
      }, {validator: EqualPasswordsValidator.validate('password', 'repeatPassword')})
    });

    this.userId = this.form.controls['userId'];
    this.name = this.form.controls['name'];
    this.email = this.form.controls['email'];
    this.locale = this.form.controls['locale'];
    this.passwords = <FormGroup> this.form.controls['passwords'];
    this.password = this.passwords.controls['password'];
    this.repeatPassword = this.passwords.controls['repeatPassword'];

    this.toasterService = toasterService;
  }

  ngOnInit() {
  }

  public onSubmit(values:any):void {

    if (this.form.valid) {
      this.loading = true;

      const user = {
        userId : values.userId,
        email: values.email,
        userName : values.name,
        password: values.passwords.password,
        status: 'Disabled',
        roles: ['Developer'],
        locale: values.locale
      };

      this.translateService.get(['home.signup.title',
      'home.signup.alert.signup-success',
      'home.signup.alert.email-is-inuse',
      'home.signup.alert.signup-failed']).subscribe((messages: any) => {
        this.guestUserService.join(user).subscribe(
          user => {
            this.toasterService.pop('info', messages['home.signup.title'], messages['home.signup.alert.signup-success']);
            this.loading = false;
            this.router.navigate(['/member/login']);
          },
          error => {
            this.loading = false;
            switch (error.status) {
              case HttpStatusCode.CONFLICT:
                this.toasterService.pop('error', messages['home.signup.title'], messages['home.signup.alert.email-is-inuse']);
                break;
              default:
                this.toasterService.pop('error', messages['home.signup.title'], messages['home.signup.alert.signup-failed']);
                break;
            }
          }
        );
      });
    }


  }

}
